import gql from "graphql-tag";

export const DELETE_USER_TYPE_TEMPLATE = gql`
  mutation deleteUserTypeTemplate($id: ID!) {
    deleteUserTypeTemplate(id: $id)
  }
`;
